<script>
    import { onMount } from 'svelte';

  export let address = "";
  export let phoneNumber = "";
  let errorMsg = "";
  /** @type{import('svelte/store').Writable<boolean>} */
  export let isValidStep;

  onMount(() => {
    validate();
  });


  function validate() {
    errorMsg = "";

    // Simple validation for address
    if (!address) {
      errorMsg = "Моля въведете адрес"
      isValidStep.set(false);
      return;
    }

    // Simple validation for phone number
    // Assuming phone number to have 10 digits (common in many countries without the country code)
    if (!phoneNumber.match(/^\d{9,}$/)) {
      errorMsg = "Моля въведете валиден телефон";
      isValidStep.set(false);
      return;
    }

    // If everything is okay
    isValidStep.set(true);
  }

  function onChange() {
    validate();
  }
  
</script>

<div class="container mx-auto p-4">
  <form on:submit|preventDefault={validate} class="space-y-4">
    <span class="font-bold text-lg">Моля въведете адрес за доставка и телефонен номер за връзка</span>
    <div>
      <label for="address" class="block text-sm font-medium">Адрес:</label>
      <input type="text" bind:value={address} id="address" placeholder="Твоят адрес за доставка"
        class="mt-1 px-3 py-2 w-full border rounded-md focus:ring focus:border-blue-300" on:keyup={onChange} />
    </div>
    
    <div>
      <label for="phoneNumber" class="block text-sm font-medium">Телефон:</label>
      <input type="text" bind:value={phoneNumber} id="phoneNumber" placeholder="Твоят телефонен номер"
        class="mt-1 px-3 py-2 w-full border rounded-md focus:ring focus:border-blue-300" on:keyup={onChange} />
      <p class="text-sm mt-2">Моля, уверете се, че телефонният номер е правилен, тъй като той е важен за потвърждаване на поръчката.</p>
    </div>
    
    {#if errorMsg}
      <div class="text-red-500">{errorMsg}</div>
    {/if}
    
  </form>
</div>

